import { News } from "../../types/news";
import api from "../api";

export const getNewsList = async (): Promise<{
  data: News[];
}> => {
  const { data } = await api.get("/v2/news");
  return data;
};
